import React from "react";
import AuthHeader from "../components/authHeader/AuthHeader";
import classes from "./Layout.module.css";
const Layout = (props) => {
  return (
    <div className={classes["container_auth"]}>
      <AuthHeader
        title={props.title}
        commands={props.commands}
        path={props.path}
        link={props.link}
      />
      <form onSubmit={props.onSubmitHandler}>{props.children}</form>
    </div>
  );
};

export default Layout;
